import React from "react";
import Table from "react-bootstrap/Table";
import "./ChargebeeSubscription.css";
import { useQuery } from "@apollo/client";
import { SUBSCRIPTION_RENEWAL_HISTORY_QUERY } from "./query";
import Loader from "./../Loader/Loader";
import moment from "moment-timezone";
var ChargebeeSubscription = function ChargebeeSubscription(props) {
  var _useQuery = useQuery(SUBSCRIPTION_RENEWAL_HISTORY_QUERY),
    subscriptionRenewalHistoryData = _useQuery.data,
    subscriptionRenewalHistoryError = _useQuery.error,
    subscriptionRenewalHistoryLoading = _useQuery.loading,
    refetch = _useQuery.refetch;
  React.useEffect(function () {
    refetch === null || refetch === void 0 ? void 0 : refetch();
  }, [props.location.key]);
  if (subscriptionRenewalHistoryLoading) {
    // return <div>Loading...</div>;
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  if (subscriptionRenewalHistoryError) {
    return /*#__PURE__*/React.createElement("div", null, "Error");
  }
  if (!subscriptionRenewalHistoryData) {
    return null;
  }

  //console.log("subscriptionRenewalHistoryData", subscriptionRenewalHistoryData);

  return /*#__PURE__*/React.createElement("div", {
    className: "chargebee-subscription-root"
  }, /*#__PURE__*/React.createElement(Table, {
    responsive: true,
    className: "chargebee-subscription-root-table"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Name"), /*#__PURE__*/React.createElement("th", null, "Email"), /*#__PURE__*/React.createElement("th", null, "Subscription Id"), /*#__PURE__*/React.createElement("th", null, "Subscription Quantity"), /*#__PURE__*/React.createElement("th", null, "Current Quantity"), /*#__PURE__*/React.createElement("th", null, "Due Date"))), /*#__PURE__*/React.createElement("tbody", null, (subscriptionRenewalHistoryData === null || subscriptionRenewalHistoryData === void 0 ? void 0 : subscriptionRenewalHistoryData.subscriptionRenewalHistory.length) > 0 ? subscriptionRenewalHistoryData === null || subscriptionRenewalHistoryData === void 0 ? void 0 : subscriptionRenewalHistoryData.subscriptionRenewalHistory.map(function (historyData) {
    return /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, historyData.name), /*#__PURE__*/React.createElement("td", null, historyData.email), /*#__PURE__*/React.createElement("td", null, historyData.subscriptionId), /*#__PURE__*/React.createElement("td", null, historyData.subscriptionQuantity), /*#__PURE__*/React.createElement("td", null, historyData.currentQuantity), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", null, moment.unix(Number(historyData.billingDate)).format("d MMM, YYYY")), /*#__PURE__*/React.createElement("div", null, "(", Number(historyData.daysDiff) > 1 ? "".concat(historyData.daysDiff, " days") : "".concat(historyData.daysDiff, " day"), ")")));
  }) : /*#__PURE__*/React.createElement("tr", {
    colspan: "6",
    align: "center"
  }, "No data found !!!"))));
};
export default ChargebeeSubscription;